import { enqueueSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useVincularCarcinogenicReportMutation } from '../../../services/carcinogenicApi';

const useCancerigenos = ({ refetchPresentations }: { refetchPresentations?: () => void }) => {
    const { t } = useTranslation('presentaciones');
    const [vincularReporte] = useVincularCarcinogenicReportMutation();

    const getSRTAuthTicket = async (): Promise<{ success: boolean }> => {
        return Promise.resolve({ success: true });
    };

    const sendCancerigenoToSRT = async (
        id: number
    ): Promise<{ success: boolean; error?: string }> => {
        try {
            await vincularReporte(id).unwrap();
            return { success: true };
        } catch (err: any) {
            const errorMessage = err?.data?.message || t('alerts.errors.srtServiceFailed');
            return { success: false, error: errorMessage };
        }
    };

    const handleApproveCancerigeno = useCallback(
        async (item: any) => {
            try {
                const ticketResponse = await getSRTAuthTicket();
                if (!ticketResponse?.success) {
                    enqueueSnackbar(t('alerts.errors.authSRTFailed'), { variant: 'error' });
                    return;
                }

                const approveResponse = await sendCancerigenoToSRT(item.id);
                if (!approveResponse?.success) {
                    enqueueSnackbar(approveResponse?.error || t('alerts.errors.srtServiceFailed'), {
                        variant: 'error'
                    });

                    return;
                }

                enqueueSnackbar(t('alerts.success.approved'), { variant: 'success' });
                refetchPresentations?.();
            } catch (error) {
                enqueueSnackbar(t('alerts.errors.unexpected'), { variant: 'error' });
            }
        },
        [t, refetchPresentations]
    );

    return {
        handleApproveCancerigeno
    };
};

export default useCancerigenos;
